import { render, staticRenderFns } from "./competitions.vue?vue&type=template&id=6196b32a&scoped=true&lang=html&"
import script from "./competitions.vue?vue&type=script&lang=js&"
export * from "./competitions.vue?vue&type=script&lang=js&"
import style0 from "./competitions.vue?vue&type=style&index=0&id=6196b32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6196b32a",
  null
  
)

export default component.exports